export default __webpack_public_path__ + "static/violetCrumbelText-575e8ce921c7f548be31c978468b6977.png";